import appLocaleData from 'react-intl/locale-data/ja';
import jaMessages from '../locales/ja-JA';

const JaLang = {
    messages: {
        ...jaMessages
    },
    locale: 'ja-JA',
    data: appLocaleData
};
export default JaLang;